import { render, staticRenderFns } from "./DH17.vue?vue&type=template&id=597971c1"
import script from "./DH17.vue?vue&type=script&lang=js"
export * from "./DH17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports